import { List, Map } from 'immutable'
import { createSelector } from 'reselect'
import * as constants from './constants'
import { currentUser } from 'app/modules/user/selectors'

export const root = (state) => state.get('conversationBulkUpdate')

export const currentBulkUpdateRequestId = (state) => root(state).get('currentUpdateRequestId')
export const bulkUpdateRequestsById = (state) => root(state).get('updateRequestsById', Map())
export const bulkUpdateRequestStatusesById = (state) => root(state).get('statusByUpdateRequestId', Map())
export const bulkUpdateRequestIdsByInboxId = (state) => root(state).get('updateRequestIdsByInboxId', Map())

export const bulkUpdateRequestsNotFromCurrentUser = createSelector(
  [
    currentUser,
    bulkUpdateRequestsById,
  ],
  (currentUser, bulkUpdateRequestsById) => {
     const requests = bulkUpdateRequestsById.filter((value, key, iter) => {
      return value.has('updaterId') && value.get('updaterId') !== currentUser.id

     })
    return requests
  })

export const currentBulkUpdateConversationIds = createSelector(
  [
    currentBulkUpdateRequestId,
    bulkUpdateRequestsById,
  ],
  (currentBulkUpdateRequestId, bulkUpdateRequestsById) => {
    return bulkUpdateRequestsById.getIn([currentBulkUpdateRequestId, 'conversationIds'], List())
  })

export const currentBulkUpdateConversationStatus = createSelector(
  [
    currentBulkUpdateRequestId,
    bulkUpdateRequestsById,
  ],
  (currentBulkUpdateRequestId, bulkUpdateRequestsById) =>
    bulkUpdateRequestsById.getIn([currentBulkUpdateRequestId, 'conversationStatus']))

export const currentBulkUpdateStatus = createSelector(
  [
    currentBulkUpdateRequestId,
    bulkUpdateRequestStatusesById,
  ],
  (currentBulkUpdateRequestId, bulkUpdateRequestStatusesById) =>
    bulkUpdateRequestStatusesById.get(currentBulkUpdateRequestId))

export const currentBulkUpdateConversationCount = createSelector(currentBulkUpdateConversationIds,
  currentBulkUpdateConversationIds => currentBulkUpdateConversationIds.size)

export const isCurrentBulkUpdatePending = createSelector(currentBulkUpdateStatus,
  currentBulkUpdateStatus => [
    constants.REQUEST_BULK_UPDATE_PENDING,
    constants.REQUEST_BULK_UPDATE_SUCCESS,
    constants.RECEIVE_BULK_UPDATE_PENDING,
  ].includes(currentBulkUpdateStatus))

export const isCurrentBulkUpdateFailed = createSelector(currentBulkUpdateStatus,
  currentBulkUpdateStatus => [
    constants.REQUEST_BULK_UPDATE_FAILED,
    constants.RECEIVE_BULK_UPDATE_FAILED,
  ].includes(currentBulkUpdateStatus))

export const bulkUpdateRequest = createSelector(
  [
    bulkUpdateRequestsById,
    (state, { updateRequestId }) => updateRequestId,
  ],
  (bulkUpdateRequestsById, updateRequestId) => bulkUpdateRequestsById.get(updateRequestId))



// WEBPACK FOOTER //
// ./src/scripts/app/modules/conversation/bulkUpdate/selectors.js